import type { AuthService } from 'types/AuthService';
import type { ISessionPort } from '@subscriptions/application/ports';

/**
 * ISessionPort over the app's AuthService. Switching store reloads the app, so the store it holds is
 * always the current one.
 */
export const createAuthSessionAdapter = (authService: AuthService): ISessionPort => ({
  getOrganizationUuid: () => authService.store?.organizationUuid ?? null,
  getUserUuid: () => authService.user?.uuid ?? null,
});
